/**
 * BrandLogo — branding consistente para la web app PsyTalent.
 *
 * Asset: public/isotipo.png (ruta pública estable; Vite copia public/ a la raíz de dist en build).
 * Reglas: no deformar (object-fit: contain), sin filtros/sombras/recolor, una instancia por vista.
 * Contraste: PNG con fondo transparente; funciona en modo claro y oscuro.
 */

const LOGO_SRC = '/isotipo.png';

export type BrandLogoVariant = 'isotipo' | 'full';

export interface BrandLogoProps {
  /** Tamaño en px (cuadrado 1:1). Default 32 para isotipo, 96–120 para full. */
  size?: number;
  /** isotipo = header/topbar; full = login/splash/landing. */
  variant?: BrandLogoVariant;
  alt?: string;
  className?: string;
  /** Lazy en header (isotipo); eager en splash/login (full, above the fold). */
  loading?: 'lazy' | 'eager';
}

const DEFAULT_SIZE_BY_VARIANT: Record<BrandLogoVariant, number> = {
  isotipo: 32,
  full: 108,
};

export function BrandLogo({
  size,
  variant = 'isotipo',
  alt = 'PsyTalent',
  className = '',
  loading,
}: BrandLogoProps) {
  const resolvedSize = size ?? DEFAULT_SIZE_BY_VARIANT[variant];
  const loadStrategy = loading ?? (variant === 'full' ? 'eager' : 'lazy');

  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      width={resolvedSize}
      height={resolvedSize}
      className={`shrink-0 object-contain ${className}`}
      style={{
        width: resolvedSize,
        height: resolvedSize,
        maxWidth: resolvedSize,
        maxHeight: resolvedSize,
      }}
      loading={loadStrategy}
    />
  );
}
